import { useQuery } from "@apollo/client";
import { LandTechEndpoints, routedClient } from "react-migration/lib/persistence/apollo";
import LT_COMPARABLE_BY_UPRN from "../apollo/ltComparablesByUPRN.gql";
import { IComparablesTransactionDTO } from "react-migration/lib/typings/comparables/Comparables";
import { useMemo } from "react";

interface LTComparableByUPRNIdHookArgs {
  uprn: string;
  skip?: boolean;
}

export function useLTComparableByUPRN({ uprn, skip }: LTComparableByUPRNIdHookArgs) {
  const result = useQuery<{
    comparablesByUPRN: IComparablesTransactionDTO[];
  }>(LT_COMPARABLE_BY_UPRN, {
    variables: { uprn },
    client: routedClient,
    context: {
      endpoint: LandTechEndpoints.Gateway,
    },
    skip,
  });

  return useMemo(
    () => ({
      data: result.data?.comparablesByUPRN?.[0],
      loading: result.loading,
      error: result.error,
    }),
    [result.data, result.loading, result.error]
  );
}
